<template>
    <div>

        <v-dialog
            v-model="$props.params.editDeviceMobileDialog"
            :fullscreen="isAdd"
            :max-width="isEdit ? '600px' : 'none'"
            transition="dialog-bottom-transition"
            @keydown.esc="closeEditDeviceMobileDialog()"
            @click:outside="closeEditDeviceMobileDialog()"
        >
            <v-card>
                <v-form @submit.prevent="processAddEditDeviceName()">
                    <v-toolbar
                        :class="dialogHeadingClasses()"
                        color="primary"
                        dark
                    >
                        <v-icon v-if="$props.params.mode === 'add'" class="mr-3"
                                v-text="icons.mdiPlusCircleOutline"></v-icon>
                        <v-icon v-else class="mr-3" v-text="icons.mdiMonitorEdit"></v-icon>
                        <div v-if="isAdd">{{ $gettext('Add a Mobile Device') }}</div>
                        <div v-else-if="isEdit">{{ $gettext('Manage your Mobile Device') }}
                        </div>
                        <v-spacer></v-spacer>
                        <v-icon class="mr-2" v-text="icons.mdiClose"
                                @click.native.stop="closeEditDeviceMobileDialog()"
                        ></v-icon>
                        <v-icon v-if="stepTracker < 3"
                                v-text="icons.mdiContentSave"
                                @click.native.stop="processAddEditDeviceName()"
                        ></v-icon>
                    </v-toolbar>

                    <v-divider></v-divider>

                    <v-stepper v-model="stepTracker">
                        <v-stepper-header v-if="isAdd && stepTracker < 3">
                            <!-- :editable="stepTracker < 3"-->
                            <v-stepper-step
                                :complete="step1Complete"
                                step="1"
                            >
                                {{ $gettext('Equipment Details') }}
                            </v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step
                                :complete="step2Complete"
                                step="2"
                            >
                                {{ $gettext('Configuration Management') }}
                            </v-stepper-step>
                        </v-stepper-header>

                        <v-stepper-items>
                            <v-stepper-content :class="{'ma-0 pa-0': isEdit }" step="1">
                                <v-card-text class="mt-4">
                                    <v-container>
                                        <v-row>
                                            <v-col :md="isAdd ? 6 : 12" cols="12">
                                                <div class="text-h6 mb-8">{{ $gettext('Smartphone Details') }}</div>
                                                <v-row>
                                                    <v-col>
                                                        <v-text-field
                                                            v-model="editDeviceName"
                                                            :error-messages="editDeviceNameErrors"
                                                            :label="$gettext('Smartphone name')"
                                                            :placeholder="$gettext('Smartphone name')"
                                                            autofocus
                                                            outlined
                                                            required
                                                            @blur="$v.editDeviceName.$touch()"
                                                            @input="$v.editDeviceName.$touch()"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>


                                                <div>
                                                    <div class="text-h6 mb-8">{{
                                                            $gettext('Smartphone Parameters')
                                                        }}
                                                    </div>

                                                    <v-row>
                                                        <v-col>
                                                            <!--                                                :rules="[v => !!v || $gettext('Server is required')]"-->
                                                            <v-select
                                                                v-model="phone.server"
                                                                :error-messages="phoneServerErrors"
                                                                :items="servers"
                                                                :label="$gettext('MDM server')"
                                                                outlined
                                                                @blur="$v.phone.server.$touch()"
                                                                @change="$v.phone.server.$touch()"
                                                                @input="$v.phone.server.$touch()"
                                                            >
                                                            </v-select>
                                                        </v-col>
                                                        <v-col>

                                                            <!-- :rules="[v => !!v || $gettext('Account Login is required')]"-->

                                                            <v-text-field
                                                                v-model="phone.account"
                                                                :error-messages="phoneAccountErrors"
                                                                :label="$gettext('MDM account login')"
                                                                outlined
                                                                @blur="$v.phone.account.$touch()"
                                                                @input="$v.phone.account.$touch()"
                                                            ></v-text-field>

                                                        </v-col>
                                                    </v-row>

<!--                                                    @blur="$v.phone.password.$touch()"-->
<!--                                                    @input="$v.phone.password.$touch()"-->
<!--                                                        :error-messages="phonePasswordErrors"-->
                                                    <v-text-field
                                                        v-model="phone.password"
                                                        :label="$gettext('MDM account password (not applicable now)')"
                                                        outlined
                                                        disabled
                                                    ></v-text-field>

                                                    <!-- <v-btn class="primary mb-5" rounded @click="underDevelopment()">
                                                        {{ $gettext('Test Smartphone Credentials') }}
                                                    </v-btn> -->
                                                </div>

<!--                                                <div class="text-h6 mb-8">{{ $gettext('Status') }}</div>

                                                <v-switch
                                                    v-model="active"
                                                    :false-value="0"
                                                    :label=" active ? $gettext('Active') : $gettext('Inactive')"
                                                    :placeholder="$gettext('Status')"
                                                    :true-value="1"
                                                    outlined
                                                ></v-switch>-->

                                            </v-col>
                                            <v-col v-if="$vuetify.breakpoint.mdAndUp && isAdd" cols="6">

                                                <div class="text-center ml-10">
                                                    <!--                                                TODO: make this a bit mild on the dark mode, as it's white -->
                                                    <!--                                                       :gradient="isDark ? 'to top right, rgba(100,115,201,.13), rgba(25,32,72,.2)' : ''" -->
                                                    <v-img
                                                        :gradient="isDark ? 'to top right, rgb(148, 156, 162, .1), rgb(148, 156, 162, .3)' : ''"
                                                        class="rounded-xl"
                                                        src="img/mobile-step1.jpg"
                                                    />
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>


                                <v-divider></v-divider>

                                <v-card-actions color="secondary">
                                    <v-spacer></v-spacer>
                                    <v-btn class="primary" type="button"
                                           @click.native.stop="closeEditDeviceMobileDialog()">
                                        {{ $gettext('Close') }}
                                    </v-btn>
                                    <v-btn class="primary" type="submit">
                                        <span v-if="isAdd">{{ $gettext('Next') }}</span>
                                        <span v-if="isEdit">{{ $gettext('Save') }}</span>
                                    </v-btn>
                                </v-card-actions>


                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <configure-device
                                    :chosen-model="chosenModel"
                                    @update-chosen-model="(chosenModelValue) => {updateChosenModel(chosenModelValue)}"
                                    @update-folder-name="(folderNameValue) => {updateFolderName(folderNameValue)}"
                                    @device-added-successfully="processAddEditDeviceName()"
                                ></configure-device>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <v-slide-y-transition>
                                    <div>
                                        <p class="subtitle-1">
                                            <v-icon class="primary--text mr-2" v-text="icons.mdiCheckCircle"></v-icon>
                                            {{
                                                $gettext('Configuration added successfully. What would you like to do next?')
                                            }}
                                        </p>
                                        <v-btn class="mr-2" color="primary" rounded
                                               @click="closeEditDeviceMobileDialog()"
                                               v-text="$gettext('Close This Pop-up')"></v-btn>
                                        <v-btn class="mr-2" color="primary" rounded
                                               @click="takeUserToMobileAppsDialog()"
                                               v-text="$gettext('Manage Apps')"></v-btn>
                                    </div>
                                </v-slide-y-transition>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-form>
            </v-card>
            <snackbar ref="snackbar"></snackbar>
        </v-dialog>

    </div>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import Vue from 'vue'

import Vuelidate from 'vuelidate'
import {maxLength, minLength, required, requiredIf} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigUsers from '@/mixins/database/MixinConfigUsers'
import MixinVuelidate from '@/mixins/MixinVuelidate'
import {mapWritableState} from 'pinia'
import {useUsersStore} from '@/stores/UsersStore'
import {findIndex} from 'lodash'
import {useMdmStore} from '@/stores/MdmStore'
import {usePhoneTypesStore} from '@/stores/PhoneTypesStore'
import ConfigureDevice from "@/components/tabs/mobile/ConfigureDevice.vue";
import {usePhonesStore} from "@/stores/PhonesStore";
import MixinConfiguration from "@/mixins/mobile_apps/MixinConfiguration";
import Constants from "@/assets/js/constants";
import MixinDark from "@/mixins/database/MixinDark";

Vue.use(Vuelidate)

const phoneDefinition = {
    server: '',
    account: '',
    password: '',
}
export default {
    components: {ConfigureDevice, Snackbar},
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigUsers, MixinVuelidate, MixinConfiguration, MixinDark],
    props: {
        params: {
            required: true,
            type: Object,
        },
    },
    watch: {

        /*stepTracker(newVal, oldVal) {

            let self = this

            if (parseInt(newVal) === 1 && parseInt(oldVal) === 2) {
                self.$props.params.mode = 'edit'
            }

        },*/

        // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
        params: {

            handler(newVal, oldVal) {

                let self = this

                if (newVal.editDeviceMobileDialog) {

                    if (self.$props.params.mode === 'add') {
                        self.resetForm()
                    } else {
                        self.editDeviceName = self.$props.params.deviceName
                        // self.active = self.$props.params.active
                    }

                } else {
                    self.resetForm()
                }


            },
            deep: true,
            // immediate: true,

        }

    },
    mounted() {

        let self = this

        self.userCategoryParentIndex = findIndex(self.users, {key: self.$props.params.userCategoryParent})
        self.userParentIndex = findIndex(self.users[self.userCategoryParentIndex].value, {key: self.$props.params.userParent})
        // self.active = self.$props.params.active

        if (self.$props.params.mode === 'edit') {

            // Mounted only fills in the dialog for the first time, the rest of the time it is filled by the watcher
            self.editDeviceName = self.$props.params.deviceName

            let devices = self.users[self.userCategoryParentIndex].value[self.userParentIndex].value.devices

            self.deviceIndex = findIndex(devices, {key: self.$props.params.deviceName})

            // This breaks the reactivity and fixes: A bug where, if we were making edits for the mdm fields, and if we were not saving changes, still the changes were being persisted for the session
            if (self.deviceIndex > -1 && typeof devices[self.deviceIndex].value.phone !== 'undefined') {
                self.phone = JSON.parse(JSON.stringify(devices[self.deviceIndex].value.phone))
            }

        } else if (self.$props.params.mode === 'add') {
            self.phone = JSON.parse(JSON.stringify(phoneDefinition))
        }


        // --
        self.configurationName = self.users[self.userCategoryParentIndex].value[self.userParentIndex].key + ' ' + self.editDeviceName

    },
    data() {
        return {

            stepTracker: 1,
            step1Complete: false,
            step2Complete: false,
            allAddedSuccessfully: false,

            folderName: '',

            configurationName: '',

            editDeviceName: '',
            // active: '',
            phone: phoneDefinition,
            userCategoryParentIndex: -1,
            userParentIndex: -1,
            deviceIndex: -1,

        }
    },

    methods: {

        underDevelopment() {
            this.$refs.snackbar.showSnackbar(this.$gettext('This feature is under development. It should be available in the next version. Thank you for your patience.'))
        },

        /**
         *
         * Check for uniqueness across all categories and users
         *
         * @param account
         * @param server
         * @param password
         * @param deviceName
         */
        checkIfPhoneParametersAreUnique(account, server, password, deviceName) {

            let self = this
            let isUnique = true

            self.users.forEach((userCategory) => {

                userCategory.value.forEach((user) => {

                    if (typeof user.value.devices !== 'undefined') {

                        user.value.devices.forEach((device) => {

                            if (device.key !== deviceName) {

                                if (device.value.phone?.account === account && device.value.phone?.server === server && device.value.phone?.password === password) {
                                    isUnique = false
                                }

                            }

                        })

                    }

                })

            })

            return isUnique

        },

        async takeUserToMobileAppsDialog() {

            let self = this

            let group = JSON.parse(JSON.stringify(self.$props.params.userCategoryParent))
            let user = JSON.parse(JSON.stringify(self.$props.params.userParent))
            let device = JSON.parse(JSON.stringify(self.editDeviceName))

            self.closeEditDeviceMobileDialog();

            self.$emit('open-manage-apps-dialog', {
                group,
                user,
                device,
            })

            // let homeComponent = self.genericComponentGetComponent('Home')
            // homeComponent.currentTab = Constants.mobileAppsTabId;

        },

        updateChosenModel(val) {
            this.chosenModel = val;
        },
        updateFolderName(val) {
            this.folderName = val;
        },

        async processAddEditDeviceName() {

            let self = this

            if (self.stepTracker === 1) {

                self.$v.$touch()
                await self.$v.$invalid
                await self.$nextTick()
                await self.$nextTick() // safety net


                setTimeout(() => {

                    if (!self.$v.$invalid) {

                        let value = {
                            // active: self.active,
                            phone: JSON.parse(JSON.stringify(self.phone))
                        }

                        let newDeviceName = self.editDeviceName;
                        let valueToUpdate = {
                            key: newDeviceName,
                            value
                        }

                        if (self.$props.params.mode === 'edit') {

                            let previousDeviceName = self.$parent.editDeviceNameField;
                            self.configUserProcessUpdateUserChildNode(self.$props.params.userCategoryParent, self.$props.params.userParent, previousDeviceName, valueToUpdate, 'devices', self.$gettext('Equipment'))

                            self.$parent.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Equipment %{ equipment } updated successfully.'), {equipment: newDeviceName}))

                            self.configurations.forEach((c) => {
                                if (c.value.user_group === self.$props.params.userCategoryParent && c.value.user === self.$props.params.userParent && c.value.device === previousDeviceName) {
                                    c.value.device = newDeviceName
                                    /* we are no longer storing the credentials in the phones.json
                                    c.value.credentials = {
                                        server: self.phone.server,
                                        account: self.phone.account,
                                        password: self.phone.password,
                                    }*/
                                }
                            })

                            self.closeEditDeviceMobileDialog()

                            // Change configuration name too.
                            let configurationIndex = findIndex(self.configurations, {key: self.$props.params.userParent + ' ' + previousDeviceName})
                            if (configurationIndex > -1) {
                                self.configurations[configurationIndex].key = self.$props.params.userParent + ' ' + newDeviceName
                            }

                            self.$emit('mobile-device-updated', {
                                categoryParent: self.$props.params.userCategoryParent,
                                userParent: self.$props.params.userParent,
                                previousDeviceName,
                                newDeviceName,
                                value
                            })

                        } else if (self.$props.params.mode === 'add') {

                            self.configUserAddUserChildNode(self.$props.params.userCategoryParent, self.$props.params.userParent, valueToUpdate, 'devices')

                            let confName = self.users[self.userCategoryParentIndex].value[self.userParentIndex].key + ' ' + newDeviceName;

                            const configurationToSave = {
                                key: confName,
                                value: {
                                    'phone_model': {},
                                    user_group: self.$props.params.userCategoryParent,
                                    user: self.$props.params.userParent,
                                    device: newDeviceName,
                                    /* we are no longer storing the credentials in the phones.json
                                    credentials: {
                                        server: self.phone.server,
                                        account: self.phone.account,
                                        password: self.phone.password,
                                    }*/
                                },
                            }

                            self.configurations.push(configurationToSave)

                            self.$parent.$refs.snackbar.showSnackbar(self.$gettextInterpolate(self.$gettext('Configuration %{ configuration } created successfully.'), {configuration: confName}))

                            self.currentSelectedConfiguration = confName;
                            self.currentSelectedConfigurationIndex = findIndex(self.configurations, {key: confName})
                            // self.configurationsRef.chosenModel = self.chosenModel
                            // self.$emit('selectTheConfigurationAdded', self.configurationName)

                            self.$emit('mobile-device-added', {
                                categoryParent: self.$props.params.userCategoryParent,
                                userParent: self.$props.params.userParent,
                                deviceName: newDeviceName,
                                value,
                                configurationName: confName
                            })

                            self.step1Complete = true;
                            self.stepTracker = 2;

                        }

                        // self.closeEditDeviceMobileDialog()

                    }

                }, 100)

            } else if (self.stepTracker === 2) {
                self.stepTracker = 3;
                self.step2Complete = true;
            }


        },


        closeEditDeviceMobileDialog() {
            let self = this
            // self.$emit('close-edit-device-name-dialog', 'editDeviceDialog')
            self.$props.params.editDeviceMobileDialog = false
            self.resetForm()
            self.$parent.closeDialog('addEditDeviceMobileDialog')
        },
        resetForm() {

            let self = this
            self.$v.$reset()
            self.editDeviceName = ''
            self.phone = {
                server: '',
                account: '',
                password: '',
            }
            // self.active = ''
            self.stepTracker = 1;
            self.step1Complete = false;
            self.step2Complete = false;
            self.allAddedSuccessfully = false;
            self.folderName = '';
            self.configurationName = '';
            self.userCategoryParentIndex = -1;
            self.userParentIndex = -1;
            self.deviceIndex = -1;
            self.configurationCurrentReset();

        },
    },
    computed: {

        hasAddedAPhoneModel() {
            return this.chosenModel.length > 0
        },
        isEdit() {
            return this.$props.params.mode === 'edit'
        },
        isAdd() {
            return this.$props.params.mode === 'add'
        },
        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
            currentSelectedConfiguration: 'currentSelectedConfiguration',
            currentSelectedConfigurationIndex: 'currentSelectedConfigurationIndex',
            chosenModel: 'chosenModel',
        }),

        ...mapWritableState(useMdmStore, {
            servers: 'servers'
        }),

        ...mapWritableState(useUsersStore, {
            users: 'users'
        }),
        ...mapWritableState(usePhoneTypesStore, {
            phoneTypes: 'phoneTypes',

            // appsCommon: 'appsCommon',
        }),

        editDeviceNameErrors() {

            const errors = []
            if (!this.$v.editDeviceName.$dirty) return errors
            !this.$v.editDeviceName.required && errors.push(this.$gettext('Smartphone name is required'))
            !this.$v.editDeviceName.minLength && errors.push(this.$gettext('Smartphone name is too short'))
            !this.$v.editDeviceName.maxLength && errors.push(this.$gettext('Smartphone name is too long'))

            !this.$v.editDeviceName.isUnique && errors.push(this.$gettextInterpolate(this.$gettext('We already have a device with this name, for %{userParent} please choose another name.'), {userParent: this.$props.params.userParent}))


            return errors
        },

        phoneServerErrors() {
            const errors = []
            if (!this.$v.phone.server.$dirty) return errors
            !this.$v.phone.server.required && errors.push(this.$gettext('Server is required'))
            !this.$v.phone.server.maxLength && errors.push(this.$gettext('The text is too long'))


            return errors
        },

        phoneAccountErrors() {
            const errors = []
            if (!this.$v.phone.account.$dirty) return errors
            !this.$v.phone.account.required && errors.push(this.$gettext('Account is required'))
            !this.$v.phone.account.isUnique && errors.push(this.$gettext('These parameters are already in use'))
            !this.$v.phone.account.maxLength && errors.push(this.$gettext('The text is too long'))

            return errors
        },

        phonePasswordErrors() {
            const errors = []
            if (!this.$v.phone.password.$dirty) return errors
            !this.$v.phone.password.required && errors.push(this.$gettext('Password is required'))
            !this.$v.phone.password.maxLength && errors.push(this.$gettext('The text is too long'))

            return errors
        },

    },
    validations: {

        editDeviceName: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(60),
            async isUnique(val, vm) {

                await this.$nextTick() // Just to satisfy async method.
                return this.configUserIsDeviceUniqueForUser(val, this.$props.params.userCategoryParent, this.$props.params.userParent, this.$props.params.mode === 'edit' ? this.$props.params.deviceName : false)

            }
        },
        phone: {
            server: {
                required,
                maxLength: maxLength(300),
            },
            account: {
                required,
                maxLength: maxLength(300),
                isUnique(value, vm) {

                    return this.checkIfPhoneParametersAreUnique(value, vm.server, vm.password, this.$props?.params?.mode === 'edit' ? this.$props.params.deviceName : false)

                }
            }
            /*password: {
                required,
                maxLength: maxLength(300),
            }*/
        }

    }

}
</script>
<style type="text/scss">
/**
    Overrides the component's default styles
 */
.app-grid-right {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    /* grid-template-rows: repeat(3, 1fr); grid-template-rows: repeat(6, 1fr); row-gap: 20px; column-gap: 10px; */
    text-align: center;
}
</style>
